export default __webpack_public_path__ + "static/media/G0004.fb6081d0.png";